<template>
  <div class="app-image-uploader">
    <el-upload
      :action="action"
      :limit="4"
      :file-list="images"
      accept="image/png,image/jpg,image/jpeg"
      list-type="picture-card"
      :on-remove="handleRemove"
      :on-exceed="handleExeceed"
      :on-success="handleUploadSuccess"
      :before-upload="handleBeforeUpload"
      :on-preview="handlePictureCardPreview"
    >
      <i class="el-icon-plus"></i>
    </el-upload>
    <el-dialog :visible.sync="dialogVisible">
      <img width="100%" :src="dialogImageUrl" alt="预览图">
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'app-image-uploader',
  props: {
    action: {
      type: String,
      default: process.env.VUE_APP_IMG_SERVER
    },
    images: {
      type: Array,
      default: () => []
    }
  },

  data () {
    return {
      dialogImageUrl: '',
      dialogVisible: false
    }
  },

  methods: {
    triggerChange (fileList) {
      const imageIds = fileList.map(item => item.response.file_id)
      this.$emit('change', imageIds)
    },

    handlePictureCardPreview (file) {
      this.dialogImageUrl = file.url
      this.dialogVisible = true
    },

    handleExeceed (files, fileList) {
      this.$message({
        type: 'warning',
        message: '最多可上传4张图片！'
      })
    },

    handleRemove (files, fileList) {
      this.triggerChange(fileList)
    },

    handleBeforeUpload (file) {
      const isLt1M = (file.size / 1024 / 1024) < 1

      if (!isLt1M) {
        this.$message({
          type: 'warning',
          message: '只能上传小于1MB的图片！'
        })
      }

      return isLt1M
    },

    handleUploadSuccess (res, file, fileList) {
      // console.log('res', res)
      // console.log('file', file)
      // console.log('fileList', fileList)
      this.triggerChange(fileList)
    }
  }
}
</script>

<style lang="scss">
.app-image-uploader {
  .el-upload--picture-card {
    width: 118px;
    height: 118px;
    line-height: 118px;
  }
  .el-upload-list--picture-card .el-upload-list__item {
    width: 118px;
    height: 118px;
  }
  .el-upload-list--picture-card .el-upload-list__item-thumbnail {
    object-fit: cover;
  }
}
</style>
